<template>
  <div>
    <div class="x-oilBox" v-if="goods">
      <div class="border"></div>
      <div class="middle flex">
        <div class="imgBox"><img :src="goods.mainImage" /></div>
        <div class="flex1">
          <div
            class="title"
            v-html="goods.name.replace(/(\r\n|\n|\r)/, '<br />')"
          ></div>
          <div class="spec">规格：{{ goods.volume }}</div>
          <div class="money">
            ￥<span style="font-size: 16px"
              >{{ goods.price }}/{{ goods.unitName }}</span
            >
          </div>
        </div>
      </div>
      <div class="border"></div>
    </div>
    <div style="margin-bottom: 50px;">
      <div class="oilMain vux-1px-b vux-1px-t">
        <div class="vux-1px-b">
          <x-input
            :title="title1"
            text-align="right"
            placeholder="输入订购数量"
            v-model="params.quantity"
            placeholder-align="right"
          ></x-input>
        </div>

        <div class="vux-1px-b">
          <selector
            title="订购主体"
            direction="rtl"
            placeholder="请选择订购主体"
            v-model="params.clientType"
            :options="typeList"
          ></selector>
        </div>

        <div class="vux-1px-b" v-if="params.clientType == 2">
          <selector
            title="公司"
            direction="rtl"
            placeholder="请选择公司"
            v-model="params.companyId"
            :options="companyList"
          ></selector>
        </div>

        <div class="vux-1px-b">
          <x-input
            title="买家"
            text-align="right"
            disabled="disabled"
            placeholder="输入真实姓名"
            v-model="params.contactName"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
          <x-input
            title="联系方式"
            text-align="right"
            disabled="disabled"
            placeholder="输入联系方式"
            v-model="params.contactPhone"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
          <selector
            title="渔船编号"
            direction="rtl"
            v-model="params.shipId"
            :options="shipList"
          ></selector>
        </div>
        <div class="vux-1px-b">
          <selector
            title="付款方式"
            direction="rtl"
            v-model="params.paymentMethod"
            :options="payMethodsList"
          ></selector>
        </div>
        <div class="vux-1px-b" v-if="params.paymentMethod == 1">
          <selector
            title="*付款人"
            direction="rtl"
            v-model="params.clientId"
            :options="shareShipList"
          ></selector>
        </div>
        <!--        <div class="vux-1px-b" v-if="params.paymentMethod == 1">-->
        <div class="vux-1px-b" v-if="params.paymentMethod == 1">
          <selector
            title="*付款银行卡"
            direction="rtl"
            v-model="params.bankId"
            :options="bankList"
          ></selector>
        </div>
        <div>
          <checklist
            :options="commonList"
            required="true"
            v-model="checkType"
            :max="1"
            @on-change="change"
          ></checklist>
        </div>
        <div class="vux-1px-b" v-if="params.type == 1">
          <datetime
            placeholder="请选择时间"
            format="YYYY-MM-DD HH:mm"
            v-model="params.useTime"
            title="用油时间"
          ></datetime>
        </div>
        <div class="vux-1px-b">
          <x-input
            title="经度"
            text-align="right"
            placeholder="请输入"
            v-model="params.longitude"
            placeholder-align="right"
          ></x-input>
        </div>
        <div class="vux-1px-b">
          <x-input
            title="纬度"
            text-align="right"
            placeholder="请输入"
            v-model="params.latitude"
            placeholder-align="right"
          ></x-input>
        </div>
<!--        <div class="vux-1px-b">-->
<!--          <selector-->
<!--            title="溯源"-->
<!--            direction="rtl"-->
<!--            v-model="params.origin"-->
<!--            :options="originList"-->
<!--          ></selector>-->
<!--        </div>-->
        <div v-if="params.type == 1">
          <x-textarea title="用油地址" v-model="params.address"></x-textarea>
        </div>
      </div>
      <div class="oilMain vux-1px-b vux-1px-t">
        <div>
          <x-textarea
            title="订单备注"
            text-align="right"
            placeholder="输入备注"
            v-model="params.remark"
            placeholder-align="right"
          ></x-textarea>
        </div>
        <div style="border-top: 1px solid #e8e8e8;padding: 5px 10px;box-sizing: border-box;font-size: 12px;color: #aaa;background-color: #F6F6F6;">
        提示：下单后，您提供的收货信息可能会提供给供油方，以便其与您联系加油！
        </div>
        <div class="heji" v-if="params.type != 1">
          <span style="margin-right: 5px">合计金额:</span>¥{{ total }}
        </div>
      </div>
    </div>
    <div class="footer flex">
      <div class="flex1">
        <span v-if="params.type == 1">
          <span class="footerLine1">合计：</span>
          <span style="color: #FF3600">¥{{ total }}</span>
        </span>
        <span v-else>
          <span class="footerLine1"
            >预付：<span style="color: #FF3600">￥</span></span
          >
          <input
            class="yufu"
            v-model="params.prepaidAmount"
            @change="prepaidAmountChange"
          />
        </span>
      </div>
      <div class="buyButton" @click="validate">立即购买</div>
    </div>
    <confirm
      v-model="show"
      title="提示"
      content="请确认信息无误，是否购买？"
      @on-confirm="onConfirm"
    >
    </confirm>

    <confirm
      v-model="show1"
      title="操作提示"
      confirm-text="前去完善"
      @on-confirm="onConfirm1"
    >
      <p style="text-align:center;">请先绑定银行卡</p>
    </confirm>
    <confirm
      v-model="show2"
      title="操作提示"
      confirm-text="前去完善"
      @on-confirm="onConfirm2"
    >
      <p style="text-align:center;">请先绑定银行卡</p>
    </confirm>
    <confirm
      v-model="show3"
      title="操作提示"
      content="暂无渔船，是否先添加渔船？"
      confirm-text="前去新增"
      @on-confirm="onConfirm3"
    >
      <p style="text-align:center;">尚未绑定渔船，是否前去添加渔船</p>
    </confirm>
  </div>
</template>

<script>
import { getProductDetail } from "@/api/goods";
import { useApi } from "@/hooks";
import { getShipList, getPayerList } from "@/api/ship";
import { createOrder, getOrderRecord } from "@/api/order";
import { orderPaymentMethod } from "../../api/order";
import { bankActiveList } from "../../api/bank";
import { Checklist } from "vux";
import { XInput } from 'vux'
import { getCompanyList } from "../../api/identify";
import { BigNumber } from 'bignumber.js'

const rules = {
  quantity: "required|numeric",
  // contactName: "required",
  contactPhone: "required|phone",
  // shipId: "required",
  // clientId: "required",
  // useTime: "required"
  // address: "required"
  type: "required"
};

const attrs = {
  quantity: "数量",
  // contactName: "买家",
  contactPhone: "手机",
  // shipId: "渔船编号",
  type: "立即付款或预定付款"
  // clientId: "付款人",
  // useTime: "用油时间",
  // address: "用油地址"
};

export default {
  name: "orderBuyDetail",
  props: {
    id: {
      type: String
    }
  },
  components: {
    Checklist,XInput
  },
  data() {
    return {
      commonList: [
        { key: "1", value: "立即付款" },
        { key: "2", value: "预定付款（提前预定，随时用）" }
      ],
      goods: null,
      show: false,
      show1: false,
      show2: false,
      show3: false,
      shipList: [],
      shareShipList: [],
      bankList: [],
      typeList: [],
      companyList: [],
      payMethodsList: [],
      params: {
        clientType: 1,
        address: "",
        bankId: "",
        contactName: "",
        contactPhone: "",
        quantity: "",
        orderAmount: "",
        clientId: "",
        paymentMethod: "",
        remark: "",
        shipId: "",
        useTime: "",
        type: "",
        prepaidAmount: "",
        companyId: "",
        longitude: "",
        latitude: "",
        // origin: 1
      },
      // originList: [
      //   { key: "1", value: "默认" },
      //   { key: "2", value: "溯源" }
      // ],
      title1: "",
      checkType: "1"
    };
  },
  computed: {
    total() {
      if (this.goods && this.params.quantity > 0) {
        return new BigNumber(this.goods.price).multipliedBy(this.params.quantity).toFixed(2);
      } else {
        return 0;
      }
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    this.fetchDetail();
    this.fetchPaymentMethod();
    // this.fetchShipList();
    if (this.userInfo) {
      const { realName, phone } = this.userInfo;
      this.params.contactName = realName;
      this.params.contactPhone = phone;
    }
    getOrderRecord().then(res => {
      this.params = {
        ...this.params,
        ...res
      };
    });
    getCompanyList()
      .then(res => {
        if (res) {
          this.companyList = res.map(x => {
            return {
              key: x.id,
              value: x.companyName
            };
          });
          this.typeList.push(
            {
              key: "1",
              value: "个人"
            },
            {
              key: "2",
              value: "公司"
            }
          );
        } else {
          this.typeList.push({
            key: "1",
            value: "个人"
          });
        }
      })
      .catch(err => {
        this.$showError(err);
      });
  },
  watch: {
    "params.quantity"(e) {
      if (this.goods && this.params.quantity > 0) {
        this.params.prepaidAmount = ((e * this.goods.price) / 2).toFixed(2);
      } else {
        this.params.prepaidAmount = 0;
      }
    },
    "params.clientType"() {
      this.params.bankId = "";
      this.params.companyId = "";
    },
    "params.companyId"() {
      this.fetchPaymentMethod();
    },
    "params.paymentMethod"(val, oldVal) {
      this.params.bankId = "";
      if (oldVal) {
        this.fetchShipList();
      }
    },
    "params.clientId"() {
      this.fetchBankActiveList();
    }
  },
  methods: {
    prepaidAmountChange(e) {
      if (e.target.value < this.params.quantity * this.goods.price * 0.2) {
        this.params.prepaidAmount = (
          this.params.quantity *
          this.goods.price *
          0.2
        ).toFixed(2);
      } else if (e.target.value > this.params.quantity * this.goods.price) {
        this.params.prepaidAmount = (
          this.params.quantity * this.goods.price
        ).toFixed(2);
      } else {
        this.params.prepaidAmount = e.target.value;
      }
    },
    change(val) {
      if (val.length > 0) {
        this.params.type = val[0];
        if (this.params.type != 1) {
          this.params.address = "";
          this.params.useTime = "";
        }
      } else {
        this.params.type = "";
        this.params.address = "";
        this.params.useTime = "";
      }
    },
    onConfirm1() {
      this.$router.push("/bankCard/bankCard");
    },
    onConfirm2() {
      this.$router.push("/bankCard/bankCard");
    },
    onConfirm3() {
      this.$router.push({
        path: "/ship/addShip",
        query: { companyId: this.params.companyId }
      });
    },
    fetchBankActiveList() {
      bankActiveList({
        clientId: this.params.clientId,
        type: this.params.clientType
      })
        .then(res => {
          this.bankList = res.map(x => {
            return {
              key: x.id,
              value: x.accountNumber
            };
          });
          if (this.bankList.length > 0) {
            this.params.bankId = this.bankList[0].key;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    fetchPaymentMethod() {
      orderPaymentMethod()
        .then(res => {
          this.payMethodsList = res.map(x => {
            return {
              key: x.value,
              value: x.name
            };
          });

          if (this.payMethodsList.length > 0 && !this.params.paymentMethod) {
            this.params.paymentMethod = this.payMethodsList[0].key;
          }
          this.fetchShipList();
          // this.fetchPayerList();
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    validate() {
      // if (this.params.shipId && this.params.shipId === "0") {
      //   this.$vux.toast.show({
      //     text: "请选择渔船",
      //     type: "warn"
      //   });
      // } else {
        this.$validate(this.params, rules, attrs)
          .then(() => {
            if (this.checkType == 1) {
              if (!this.params.useTime) {
                this.$showError("请选择用油时间");
              } else if (!this.params.address) {
                this.$showError("请输入用油地址");
              } else {
                this.show = true;
              }
            } else {
              this.show = true;
            }
          })
          .catch(e => {
            this.$showError(e, "warn");
          });
      // }
    },
    onConfirm() {
      this.$validate(this.params, rules, attrs)
        .then(() => {
          this.$vux.loading.show({
            transition: "",
            text: "提交中"
          });

          const params = {
            ...this.params,
            // useTime: this.params.useTime + ":00",
            useTime: this.params.useTime,
            orderAmount: this.total,
            prepaidAmount: this.params.prepaidAmount
          };
          params.goodsDetails = [
            {
              id: this.goods.id,
              version: this.goods.version,
              name: this.goods.name,
              price: this.goods.price,
              quantity: this.params.quantity
            }
          ];
          // 提交三要素认证
          createOrder(params)
            .then(res => {
              this.$vux.loading.hide();
              this.$showError("添加成功");
              this.$router.push("/order/" + res.id);
            })
            .catch(error => {
              if (error.status === 40000) {
                this.$showError(error);
                this.fetchDetail();
              }
              this.$showError(error, "warn");
            })
            .finally(() => {
              this.$vux.loading.hide();
            });
        })
        .catch(error => {
          this.$showError(error, "warn");
        });
    },
    fetchPayerList() {
      return getPayerList({
        shipId: this.params.shipId,
        paymentMethod: this.params.paymentMethod,
        type: this.params.clientType
      }).then(res => {
        const bbb = res.map(x => {
          return {
            key: x.clientId,
            value: x.clientName,
            clientId: x.clientId
          };
        });
        this.shareShipList = [];
        this.shareShipList = this.shareShipList.concat(bbb);
        if (this.shareShipList.length > 0) {
          this.params.clientId = this.shareShipList[0].clientId;
        } else {
          this.params.clientId = "";
        }
      });
    },
    fetchShipList() {
      getShipList({
        type: this.params.clientType,
        companyId: this.params.companyId
      }).then(res => {
        if (this.params.clientType == 1) {
          this.shipList = [
            {
              key: "0",
              value: "请选择渔船"
            }
          ];
        } else {
          this.shipList = [
            {
              key: "0",
              value: "请选择渔船"
            }
          ];
        }

        if (res.records.length > 0) {
          const aaa = res.records.map(x => {
            return {
              key: x.id,
              value: x.shipCode
            };
          });
          this.shipList = this.shipList.concat(aaa);
          // if (this.shipList.length > 0 && !this.params.shipId) {
          //   this.params.shipId = this.shipList[0].key;
          // }
          this.params.shipId = this.shipList[0].key;
        } else {
          // alert("暂无渔船，请先添加渔船");
          // this.$router.push("/ship/addShip");
          this.params.shipId = this.shipList[0].key;
          // this.show3 = true;
        }

        // this.fetchPayerList();
      });
    },
    fetchDetail() {
      useApi(
        getProductDetail({ id: this.id }).then(res => {
          this.goods = res;
          this.title1 = "订购数量（" + res.unitName + "）";
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.yufu {
  display: inline-block;
  float: left;
  border: none;
  color: #ff3600;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  width: 300px;
}
.heji {
  display: block;
  overflow: hidden;
  padding: 20px 30px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.x-oilBox {
  position: relative;
  background: #fff;
  margin: 10px 0;
  overflow: hidden;
  .border {
    background: url("../../assets/border.png") repeat;
    height: 1px;
    width: 100%;
  }
}
.middle {
  padding: 20px 30px;
}
.imgBox {
  width: 140px;
  height: 140px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 10px;
  color: #111111;
}
.spec {
  font-size: 12px;
  line-height: 32px;
  color: #919191;
  margin-bottom: 34px;
}
.money {
  font-size: 16px;
  color: #ff3600;
}

.oilMain {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  height: 40px;
  line-height: 40px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100px;
  background: #fff;
  line-height: 100px;
  border-top: 1px solid #e8e8e8;
}
.buyButton {
  width: 220px;
  height: 100px;
  background: #039df8;
  color: #fff;
  font-size: 15px;
  text-align: center;
}
.footerLine1 {
  margin-left: 30px;
  float: left;
}
</style>
